export * from './coreo.service';
export * from './api.service';
export * from './map.service';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/services/index.ts